import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_SERVICE_CHARGES:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_SERVICE_CHARGE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_SERVICE_CHARGE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_SERVICE_CHARGE:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_SERVICE_CHARGE:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
